import { render, staticRenderFns } from "./GlobalIngredientsModal.vue?vue&type=template&id=581b3116"
import script from "./GlobalIngredientsModal.vue?vue&type=script&lang=ts"
export * from "./GlobalIngredientsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports